// extracted by mini-css-extract-plugin
module.exports = {"recipe":"SmallRecipe_recipe__3Tl24","date":"SmallRecipe_date__5Q5ol","title":"SmallRecipe_title__1JLSH","image":"SmallRecipe_image__5Jcxp","like":"SmallRecipe_like__1hiuU"};